import layouts from './layouts';
import communicationConfig from './communication.config';
import headerConfig from './header.config';
import footerConfig from './footer.config';
import labelsConfig from './labels.config';
import copyProtectionConfig from './copy-protection.config';

export default {
  name: 'calderon-fe',
  communication: communicationConfig,
  header: headerConfig,
  footer: footerConfig,
  labels: labelsConfig,
  copyProtection: copyProtectionConfig,
  ...layouts,
};
